import gql from "graphql-tag";

const Props = gql`
	fragment CorrespondenceProps on Correspondent {
		id
		created_at
		desc
		fileUrl
		name
		admission {
			admission_date
			bed {
				id
				name
				room {
					id
					name
					ward {
						id
						name
					}
				}
			}
			discharge_date
			created_at
			id
		}
	}
`;
const LIST = gql`
	query GetCorrespondences($id: ID!, $page: Int, $limit: Int) {
		GetCorrespondents(id: $id, page: $page, limit: $limit) {
			docs {
				...CorrespondenceProps
			}
			totalDocs
			totalPages
			page
			limit
			nextPage
			prevPage
		}
	}
	${Props}
`;
const CREATE = gql`
	mutation NewCorrespondence($model: CorrespondentInput!) {
		CreateCorrespondent(model: $model) {
			message
			doc {
				...CorrespondenceProps
			}
		}
	}
	${Props}
`;
export { LIST, CREATE };
